export class SessionVarUtils {

  static setVerifyPalletsIndex(index: number)
  {
    sessionStorage.setItem('_verify_pallets_active_index', index.toString());
  }

  static removeVerifyPalletsIndex()
  {
    sessionStorage.removeItem('_verify_pallets_active_index');
  }

}
